import { ErrorMessage } from "@hookform/error-message";
import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { ValidationMessage } from "../../../../utils/constants/validationMessage";
import { integerInput, whiteSpaceCheck } from "../../../../helper/helper";
// import { ValidationMessage } from "../../utils/constants/validationMessage";
// import { integerInput, whiteSpaceCheck } from "../../helper/helper";

const EducationInformation = ({ register, errors }) => {
  return (
    <div className="wrapper mw-100 position-relative mb-5 pb-2 px-md-4 px-3">
      <span className="wrapper-heading">Education Information</span>
      <Row className="mb-3 gx-sm-3 gx-2">
        <Col xl={4} md={4} sm={6} className="mb-3">
          <Form.Group controlId="formSurname">
            <Form.Label>
              Degree <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter degree"
              name="degree"
              {...register("degree", {
                required: ValidationMessage.DEGREE_REQUIRED,
                validate: (value) => whiteSpaceCheck(value),
              })}
            />
            <ErrorMessage
              errors={errors}
              name="degree"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>
        <Col xl={4} md={4} sm={6} className="mb-3">
          <Form.Group controlId="formSurname">
            <Form.Label>
              College Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter collegeName"
              name="collegeName"
              {...register("collegeName", {
                required: ValidationMessage.COLLEGE_NAME_REQUIRED,
                validate: (value) => whiteSpaceCheck(value),
              })}
            />
            <ErrorMessage
              errors={errors}
              name="collegeName"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>

        <Col xl={4} md={4} sm={6} className="mb-3">
          <Form.Group controlId="formSurname">
            <Form.Label>
              Year of Passing <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter year of passing"
              name="yearOfPassing"
              {...register("yearOfPassing", {
                required: ValidationMessage.COLLEGE_NAME_REQUIRED,
                validate: (value) => whiteSpaceCheck(value),
              })}
              onKeyPress={(e) => integerInput(e)}
              maxLength={4}
            />
            <ErrorMessage
              errors={errors}
              name="yearOfPassing"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default EducationInformation;
